export enum COB_LIBRARY_ASSET_KEYS {
  RIGHT_ARROW_ICON = 'RIGHT_ARROW_ICON',
  RIGHT_ARROW_DISABLED_ICON = 'RIGHT_ARROW_DISABLED_ICON',
  LEFT_ARROW_ICON = 'LEFT_ARROW_ICON',
  LEFT_ARROW_DISABLED_ICON = 'LEFT_ARROW_DISABLED_ICON',
  CROSS_ICON = 'CROSS_ICON',
  TOP_IMAGE_COB_ICON = 'TOP_IMAGE_COB_ICON',
  FORM_INSTRUCTION_DIVIDER = 'FORM_INSTRUCTION_DIVIDER',
  ATTENTION_ICON = 'ATTENTION_ICON',
  SUCCESS_ICON = 'SUCCESS_ICON',
  EXIT_WARNING = 'EXIT_WARNING',
  GOOD_WORK = 'GOOD_WORK',
  ROCK_STAR = 'ROCK_STAR',
  ERROR_CROSS = 'ERROR_CROSS',
}

export type COBLibraryAssets = Record<COB_LIBRARY_ASSET_KEYS, unknown>;
